angular.module('account.roles.edit', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'ui.bootstrap.dropdown',
  'services.formErrors',
  'ngFileUpload',
]);

angular.module('account.roles.edit').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('account.roles.edit', {
      url: '/edit/:id',
      title: 'Account Roles / Edit',
      views: {
        'main@': {
          template: require('./role-edit.tpl.html'),
          controller: 'AccountRolesEditCtrl',
          resolve: {
            role: ["$stateParams", "adminResource", function($stateParams, adminResource) {
              return adminResource.findRole($stateParams.id);
            }],
            /*sports: function(adminResource) {
              return adminResource.getSports();
            },*/
          }
        }
      }
    });
}])
.controller('AccountRolesEditCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "role", "Role", "formErrors", "growl", "dateFilter", "Upload", "user", function($scope, $route, $location, $log, utility, adminResource, role, Role, formErrors, growl, dateFilter, Upload, user) { //, sport
    var slugify = function (text) {
        if (typeof text !== 'string') return text;
        return text.toString()
                .toLowerCase()
                .replace(/á/g,'a')
                .replace(/é/g,'e')
                .replace(/í/g,'i')
                .replace(/ó/g,'o')
                .replace(/ú/g,'u')
                .replace(/ã/g,'a')
                .replace(/ñ/g,'n')
                .replace(/ç/g,'c')
                .replace(/ü/g,'u')
                .replace(/^\s+|\s+$/g, "")
                .replace(/[_|\s]+/g, "-")
                .replace(/[^a-z\u0400-\u04FF0-9-]+/g, "")
                .replace(/[-]+/g, "-")
                .replace(/^-+|-+$/g, "");
      };
    $scope.dataLoaded = true;
    //$scope.sportsList = !!sports && sports.data ? sports.data : [];
    $scope.roleTypesList = [];  
    $scope.languagesList = [];

    $scope.$on('$locationChangeStart', function (event, next, current) {
        var answer = confirm("Are you sure you want to navigate away from this page");
        if (!answer) {
          event.preventDefault();
        }
    });

    $scope.closeDetailAlert = function () {
      $scope.detailAlerts = []
    }

    var deserializeData = function(data) {
      $scope.role = data;
      //$scope.role.sport = !!data.sport ? _.find($scope.sportsList, {name: data.sport}) : undefined;
    };

    $scope.addTranslation = function($event) {
      $event.preventDefault()
      var translation = {
        name: "",
        languageTag: ""
      }
      if(!$scope.role.translations) {
        $scope.role.translations = [];
      }
      $scope.role.translations.push(translation);
    };

    $scope.removeTranslation = function(index,$event) {
      $event.preventDefault()
      $scope.role.translations.splice(index, 1);
    };

    $scope.submit = function () {
      var data = angular.copy($scope.role);
      if(data.sport && data.sport.name) {
        data.sport = data.sport.name;
      }

      $scope.dataLoaded = false;
      Role.update(data, function (result) {
          $scope.dataLoaded = true;
          growl.info('Role saved!');
      }, function(error) {
          formErrors.growlErrors(error);
          $scope.dataLoaded = true;
      });

    };

    $scope.delete = function (tag) {
        if (!confirm('Are you sure you want to delete this role?')) {
          return;
        }
        Role.delete({id: role._id}, function (result) {
          setTimeout(function () {
            growl.info('Role removed!');
            $location.path('/account/roles');
          }, 1000);
        }, function(error) {
            formErrors.growlErrors(error);
            $scope.dataLoaded = true;
        });
    };

    $scope.canEdit = function() {
      return user.permissions.is_admin || !$scope.showOriginalVersion; 
    }
    $scope.isAdmin = function() {
      return user.permissions.is_admin;
    }

    deserializeData(role);
    adminResource.getRoleTypes().then(function(types){
        $scope.roleTypesList = types;
    })

    /*adminResource.getSports().then(function(sports){
      $scope.sportsList = sports && sports.data ? sports.data : [];
    });*/
    adminResource.getLanguages().then(function(languages){
      $scope.languagesList = languages;
    });
  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/roles/role-edit.js